import React from 'react';

import { paymentStatus } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import TransfersTable from 'containers/payments/credit-transfers/TransfersTable';
import { ListContainer } from 'components';
import { Typography } from '@mui/material';

const CreditTransfers = () => {
    return (
        <ListContainer>
            <Typography variant="h5" align="left" gutterBottom>
                {texts.TRANSFER_TO_FUNDS}
            </Typography>
            <TransfersTable
                listStatus={paymentStatus.PENDING_CONFIRMATION}
                title={texts.PENDING_TRANSFERS}
                hasActions
            />
            <TransfersTable listStatus={paymentStatus.CONFIRMED} title={texts.TRANSFER_HISTORY} />
        </ListContainer>
    );
};

export default CreditTransfers;
